import _classCallCheck from "/opt/crenspire/apps/portfolio/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/crenspire/apps/portfolio/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * TODO: These methods can probably be combined somehow
 * Parse HTML tags & HTML Characters
 */
var HTMLParser = /*#__PURE__*/function () {
  function HTMLParser() {
    _classCallCheck(this, HTMLParser);
  }

  _createClass(HTMLParser, [{
    key: "typeHtmlChars",

    /**
     * Type HTML tags & HTML Characters
     * @param {string} curString Current string
     * @param {number} curStrPos Position in current string
     * @param {Typed} self instance of Typed
     * @returns {number} a new string position
     * @private
     */
    value: function typeHtmlChars(curString, curStrPos, self) {
      if (self.contentType !== 'html') return curStrPos;
      var curChar = curString.substr(curStrPos).charAt(0);

      if (curChar === '<' || curChar === '&') {
        var endTag = '';

        if (curChar === '<') {
          endTag = '>';
        } else {
          endTag = ';';
        }

        while (curString.substr(curStrPos + 1).charAt(0) !== endTag) {
          curStrPos++;

          if (curStrPos + 1 > curString.length) {
            break;
          }
        }

        curStrPos++;
      }

      return curStrPos;
    }
    /**
     * Backspace HTML tags and HTML Characters
     * @param {string} curString Current string
     * @param {number} curStrPos Position in current string
     * @param {Typed} self instance of Typed
     * @returns {number} a new string position
     * @private
     */

  }, {
    key: "backSpaceHtmlChars",
    value: function backSpaceHtmlChars(curString, curStrPos, self) {
      if (self.contentType !== 'html') return curStrPos;
      var curChar = curString.substr(curStrPos).charAt(0);

      if (curChar === '>' || curChar === ';') {
        var endTag = '';

        if (curChar === '>') {
          endTag = '<';
        } else {
          endTag = '&';
        }

        while (curString.substr(curStrPos - 1).charAt(0) !== endTag) {
          curStrPos--;

          if (curStrPos < 0) {
            break;
          }
        }

        curStrPos--;
      }

      return curStrPos;
    }
  }]);

  return HTMLParser;
}();

export { HTMLParser as default };
export var htmlParser = new HTMLParser();